import { render, staticRenderFns } from "./orderService.vue?vue&type=template&id=24b83dad&scoped=true"
import script from "./orderService.vue?vue&type=script&lang=js"
export * from "./orderService.vue?vue&type=script&lang=js"
import style0 from "./orderService.vue?vue&type=style&index=0&id=24b83dad&prod&lang=less&scoped=true"
import style1 from "./orderService.vue?vue&type=style&index=1&id=24b83dad&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b83dad",
  null
  
)

export default component.exports